import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function InnovaCrystaOnRentInMumbai() {



    const cardData = {





keyword: "Innova Crysta on Rent in Mumbai",

headingDescription: "Shreesha Tours & Travels offers premium Innova Crysta on Rent in Mumbai for airport transfers, corporate travel, outstation trips, family vacations, business tours, destination weddings, pilgrimage journeys, sightseeing, VIP transportation, and long-distance travel across India. The Toyota Innova Crysta is one of the most preferred premium MPVs, known for its luxurious interiors, spacious seating, excellent ride comfort, advanced safety features, and large luggage capacity. Our chauffeur-driven Innova Crysta rental service is ideal for families, corporate executives, tourists, and groups seeking a comfortable and hassle-free travel experience. We provide well-maintained vehicles, professional chauffeurs, doorstep pickup, transparent pricing, flexible travel packages, and 24/7 customer support. Whether you need an Innova Crysta for a one-way journey, round trip, airport pickup, multi-day tour, or customized outstation travel from Mumbai, Shreesha Tours & Travels ensures punctual service, superior comfort, and a smooth journey to every destination.",

topPlaces: [
  {
    title: "Mumbai to Pune",
    description: "Pune is one of the most frequently booked destinations for Innova Crysta rentals from Mumbai. Business executives, IT professionals, and families prefer the premium comfort of Innova Crysta while traveling to Hinjawadi, Baner, Kharadi, Magarpatta, Wakad, and Pimpri-Chinchwad."
  },
  {
    title: "Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station known for Venna Lake, Arthur's Seat, Mapro Garden, strawberry farms, and panoramic viewpoints. Innova Crysta rentals are ideal for luxurious family holidays and group vacations."
  },
  {
    title: "Mumbai to Lonavala",
    description: "Lonavala is a popular weekend destination famous for Tiger Point, Bhushi Dam, Rajmachi Fort, Karla Caves, and beautiful valleys. Innova Crysta offers exceptional comfort for families and groups enjoying a relaxing road trip."
  },
  {
    title: "Mumbai to Shirdi",
    description: "Shirdi is one of India's most important pilgrimage destinations, attracting millions of Sai Baba devotees every year. Innova Crysta rentals provide spacious and comfortable travel for families and senior citizens."
  },
  {
    title: "Mumbai to Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, temples, and industrial areas. Travelers choose Innova Crysta for premium comfort during religious, business, and leisure trips."
  },
  {
    title: "Mumbai to Goa",
    description: "Goa is India's leading beach destination, offering luxury resorts, beaches, churches, forts, casinos, nightlife, and water sports. Innova Crysta is one of the best vehicles for comfortable long-distance family vacations."
  },
  {
    title: "Mumbai to Surat",
    description: "Surat is a major commercial city renowned for its diamond and textile industries. Corporate travelers prefer Innova Crysta rentals for executive travel, client meetings, and business tours."
  },
  {
    title: "Mumbai to Ahmedabad",
    description: "Ahmedabad is Gujarat's commercial capital, known for industries, business parks, heritage sites, and shopping destinations. Innova Crysta rentals ensure premium travel for both business and leisure journeys."
  },
  {
    title: "Mumbai to Kolhapur",
    description: "Kolhapur is famous for the Mahalakshmi Temple, Panhala Fort, Rankala Lake, and rich Maratha culture. Innova Crysta is a preferred choice for comfortable religious tours and family vacations."
  },
  {
    title: "Mumbai to Bangalore",
    description: "Bangalore is India's leading technology and startup hub with multinational companies, IT parks, and business centers. Innova Crysta rentals provide luxurious long-distance transportation for corporate teams, executives, and families."
  }
],



"services": [
  {
    "name": "Innova Crysta on Rent in Mumbai",
    "description": "Book Innova Crysta on Rent in Mumbai for premium chauffeur-driven travel with spacious seating, luxurious interiors, powerful performance, and well-maintained AC vehicles. Perfect for airport transfers, family vacations, corporate travel, weddings, sightseeing tours, business meetings, VIP guests, and long-distance outstation journeys with experienced drivers and 24x7 booking support."
  },
  {
    "name": "Toyota Innova Crysta Rental Mumbai",
    "description": "Choose Toyota Innova Crysta Rental Mumbai for safe, comfortable, and luxurious transportation with professional chauffeurs and premium vehicles. Our rental service is ideal for family trips, executive travel, airport transfers, corporate meetings, holiday tours, religious tours, and outstation travel across Maharashtra and India."
  },
  {
    "name": "Innova Crysta Cab Mumbai",
    "description": "Hire Innova Crysta Cab Mumbai for smooth and comfortable travel with experienced drivers and spacious luxury vehicles. Enjoy reliable transportation for local city travel, airport pickup and drop, hotel transfers, family outings, business travel, and outstation journeys with affordable pricing and flexible booking options."
  },
  {
    "name": "Innova Crysta Hire Mumbai",
    "description": "Reserve Innova Crysta Hire Mumbai for premium chauffeur-driven transportation with clean, luxury AC vehicles and professional service. Whether you require a cab for weddings, business travel, sightseeing, VIP transportation, airport transfers, or family holidays, our Innova Crysta service guarantees a comfortable journey."
  },
  {
    "name": "Innova Crysta Car Rental Mumbai",
    "description": "Book Innova Crysta Car Rental Mumbai for luxury travel with spacious seating, advanced comfort features, and experienced chauffeurs. Suitable for airport transfers, corporate events, family vacations, hotel transfers, local sightseeing, pilgrimage tours, and outstation travel with transparent pricing."
  },
  {
    "name": "Innova Crysta Taxi Service Mumbai",
    "description": "Choose Innova Crysta Taxi Service Mumbai for dependable transportation with premium vehicles, courteous drivers, and flexible travel plans. Enjoy comfortable rides for business meetings, local travel, airport transfers, family functions, weddings, and interstate journeys with excellent customer service."
  },
  {
    "name": "Innova Crysta with Driver Mumbai",
    "description": "Hire Innova Crysta with Driver Mumbai for stress-free travel with professional chauffeurs who ensure safe, punctual, and comfortable journeys. Ideal for business executives, tourists, airport transfers, wedding transportation, VIP guests, corporate travel, and family road trips."
  },
  {
    "name": "Innova Crysta Outstation Cab Mumbai",
    "description": "Book Innova Crysta Outstation Cab Mumbai for one way and round trip travel across Maharashtra, Goa, Gujarat, Karnataka, and other destinations in India. Enjoy luxury seating, spacious luggage capacity, experienced drivers, and reliable service for family holidays, corporate travel, pilgrimage tours, and weekend getaways."
  },
  {
    "name": "Innova Crysta Airport Taxi Mumbai",
    "description": "Reserve Innova Crysta Airport Taxi Mumbai for punctual airport pickup and drop with flight tracking, luggage assistance, and premium chauffeur service. Travel comfortably to and from Mumbai International and Domestic Airports in spacious luxury vehicles designed for business travelers and families."
  },
  {
    "name": "Innova Crysta Corporate Rental Mumbai",
    "description": "Choose Innova Crysta Corporate Rental Mumbai for executive transportation, employee travel, airport transfers, conferences, client meetings, and business events. Our premium chauffeur-driven vehicles ensure professionalism, punctuality, comfort, and reliable corporate travel solutions."
  },
  {
    "name": "Innova Crysta Family Cab Mumbai",
    "description": "Book Innova Crysta Family Cab Mumbai for comfortable family travel with spacious interiors, comfortable seating, large luggage space, and experienced drivers. Perfect for vacations, religious tours, weddings, sightseeing, airport transfers, and long-distance journeys with complete travel convenience."
  },
  {
    "name": "Mumbai Innova Crysta Booking",
    "description": "Complete Mumbai Innova Crysta Booking online with instant confirmation, competitive pricing, and flexible rental plans. Reserve luxury chauffeur-driven vehicles for airport transfers, local travel, corporate meetings, weddings, sightseeing tours, family functions, and outstation trips."
  },
  {
    "name": "Innova Crysta Luxury Car Rental Mumbai",
    "description": "Choose Innova Crysta Luxury Car Rental Mumbai for premium travel with elegant interiors, advanced comfort, experienced chauffeurs, and exceptional service. Ideal for VIP transportation, executive travel, luxury weddings, airport transfers, business travel, and premium outstation journeys."
  },
  {
    "name": "Innova Crysta One Way Cab Mumbai",
    "description": "Book Innova Crysta One Way Cab Mumbai for economical single-trip travel without paying return charges. Enjoy fixed pricing, luxury seating, professional drivers, comfortable AC vehicles, and hassle-free transportation for airport transfers, business travel, and intercity journeys."
  },
  {
    "name": "Innova Crysta Round Trip Taxi Mumbai",
    "description": "Reserve Innova Crysta Round Trip Taxi Mumbai for convenient return travel with flexible schedules and affordable packages. Perfect for family holidays, sightseeing tours, business trips, pilgrimage travel, destination weddings, and weekend getaways with premium comfort throughout your journey."
  },
  {
    "name": "Best Innova Crysta Rental Mumbai",
    "description": "Choose the Best Innova Crysta Rental Mumbai for luxury chauffeur-driven transportation with premium vehicles, experienced drivers, transparent pricing, and excellent customer support. Whether you need airport transfers, corporate travel, family vacations, sightseeing tours, weddings, VIP transportation, or outstation journeys, enjoy a safe, comfortable, and memorable travel experience every time."
  }
],
"tableData": [
  ["Innova Crysta on Rent in Mumbai", "Toyota Innova Crysta Rental Mumbai"],
  ["Innova Crysta Cab Mumbai", "Innova Crysta Hire Mumbai"],
  ["Innova Crysta Car Rental Mumbai", "Innova Crysta Taxi Service Mumbai"],
  ["Innova Crysta with Driver Mumbai", "Innova Crysta Outstation Cab Mumbai"],
  ["Innova Crysta Airport Taxi Mumbai", "Innova Crysta Corporate Rental Mumbai"],
  ["Innova Crysta Family Cab Mumbai", "Mumbai Innova Crysta Booking"],
  ["Innova Crysta Luxury Car Rental Mumbai", "Innova Crysta One Way Cab Mumbai"],
  ["Innova Crysta Round Trip Taxi Mumbai", "Best Innova Crysta Rental Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Luxury Innova Crysta on Rent in Mumbai",
    WhyChoosedescription: "Travel in premium comfort with Shreesha Travels by booking an Innova Crysta on rent in Mumbai. Designed for luxury, space, and performance, the Innova Crysta is an excellent choice for business executives, families, tourists, wedding guests, and long-distance travellers."
  },
  {
    WhyChooseheading: "Premium SUV for Comfortable Long Journeys",
    WhyChoosedescription: "The Innova Crysta offers spacious seating, superior suspension, powerful performance, and generous luggage capacity, making every journey relaxing whether you're travelling within Mumbai or across India."
  },
  {
    WhyChooseheading: "Perfect for Airport Transfers & Outstation Trips",
    WhyChoosedescription: "Reserve an Innova Crysta for Mumbai Airport transfers, corporate travel, sightseeing tours, family vacations, religious tours, destination weddings, and outstation trips to Pune, Goa, Nashik, Mahabaleshwar, Ahmedabad, Bengaluru, and many more destinations."
  },
  {
    WhyChooseheading: "Preferred Choice for Executive & VIP Travel",
    WhyChoosedescription: "Business professionals, corporate teams, VIP guests, and premium travellers choose the Innova Crysta for its comfort, elegant interiors, and dependable performance."
  },
  {
    WhyChooseheading: "Flexible Rental Packages to Match Your Itinerary",
    WhyChoosedescription: "Book one-way taxis, round trips, airport transfers, full-day rentals, multi-day travel packages, or customized chauffeur-driven tours according to your travel plans."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Premium Travel",
    WhyChoosedescription: "Our professional drivers are trained to provide courteous service, safe driving, and smooth transportation, ensuring a pleasant experience throughout your journey."
  },
  {
    WhyChooseheading: "Well-Maintained & Fully Sanitized Innova Crysta Fleet",
    WhyChoosedescription: "Every Innova Crysta undergoes regular servicing, cleaning, and quality inspections, offering passengers a safe, comfortable, and premium travel experience."
  },
  {
    WhyChooseheading: "Choose Shreesha Travels for Innova Crysta Rental",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking support, dependable service, and luxury chauffeur-driven travel whenever you need an Innova Crysta on rent in Mumbai."
  }
]

};

const faqData = [
  {
    question: "Why is the Innova Crysta popular for rental in Mumbai?",
    answer: "The Innova Crysta combines luxury, spacious interiors, advanced comfort, and excellent highway performance, making it ideal for premium travel."
  },
  {
    question: "How many passengers can travel in an Innova Crysta?",
    answer: "The Innova Crysta comfortably accommodates up to 6–7 passengers, depending on the seating configuration and luggage requirements."
  },
  {
    question: "Can I hire an Innova Crysta for corporate executives?",
    answer: "Yes, the Innova Crysta is widely preferred for executive travel, business meetings, VIP transportation, conferences, and airport transfers."
  },
  {
    question: "Is the Innova Crysta available for outstation tours?",
    answer: "Yes, it is available for one-way and round-trip journeys to destinations across Maharashtra and other Indian states."
  },
  {
    question: "Can I rent an Innova Crysta for weddings and family functions?",
    answer: "Yes, the vehicle is an excellent option for weddings, receptions, guest transportation, destination weddings, and special celebrations."
  },
  {
    question: "Are airport pickup and drop services available with the Innova Crysta?",
    answer: "Yes, chauffeur-driven airport transfers are available for both domestic and international terminals in Mumbai."
  },
  {
    question: "Can I book the Innova Crysta for multiple travel days?",
    answer: "Yes, customized multi-day packages are available for vacations, pilgrimages, business tours, and holiday travel."
  },
  {
    question: "What makes the Innova Crysta suitable for long-distance journeys?",
    answer: "Its spacious cabin, comfortable seating, premium suspension, powerful engine, and large luggage capacity make it ideal for extended road trips."
  },
  {
    question: "How is the Innova Crysta rental fare calculated?",
    answer: "Rental charges are based on the selected travel plan, total distance, trip duration, destination, and additional travel requirements."
  },
  {
    question: "How can I book an Innova Crysta on Rent in Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, destination, travel date, passenger count, and itinerary to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Malhotra",
    feedback: "The premium interiors and exceptional comfort of the Innova Crysta made the road trip truly enjoyable. Every aspect of the service reflected professionalism and attention to detail.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Aditi Deshpande",
    feedback: "From the booking process to the final destination, everything was handled efficiently. The spacious vehicle, smooth ride, and courteous chauffeur created a first-class travel experience.",
    rating: 5
  }
];













    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta on Rent in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/innova-crysta-on-rent-in-mumbai.webp",
  "description":
    "Book Innova Crysta on Rent in Mumbai with Shreesha Tours & Travels for premium, spacious, and comfortable chauffeur-driven travel. We provide Toyota Innova Crysta rentals available 24x7 for airport transfers, corporate travel, family vacations, weddings, sightseeing, VIP travel, and outstation journeys across Maharashtra and India.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/innova-crysta-on-rent-in-mumbai"
  }
};









    return (
        <div>
<Helmet>
  <title>Innova Crysta on Rent in Mumbai | Premium SUV Rental | +91 8355835813</title>

  <meta
    name="description"
    content="Book Innova Crysta on Rent in Mumbai with Shreesha Travels for premium chauffeur-driven SUV rentals. Hire Toyota Innova Crysta for airport transfers, local travel, corporate trips, family tours, and outstation journeys with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Innova Crysta on Rent in Mumbai, Toyota Innova Crysta Rental Mumbai, Innova Crysta Cab Mumbai, Innova Crysta Hire Mumbai, Innova Crysta Car Rental Mumbai, Innova Crysta Taxi, Innova Crysta Taxi Service Mumbai, Innova Crysta Airport Taxi Mumbai, Innova Crysta Outstation Cab Mumbai, Luxury SUV Rental Mumbai, Toyota Innova Crysta Hire Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/49.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default InnovaCrystaOnRentInMumbai;